"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityAudits = void 0;
const sdk_1 = require("../sdk");
var ActivityAudits;
(function (ActivityAudits) {
    ActivityAudits.list = (options) => {
        const url = '/activity-audits';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    ActivityAudits.get = (activityAuditId) => {
        const url = `/activity-audits/${activityAuditId}`;
        return sdk_1.SDK.axios.get(url);
    };
})(ActivityAudits = exports.ActivityAudits || (exports.ActivityAudits = {}));
//# sourceMappingURL=activity-audits.js.map